import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { IBAN_COMPONENT_ELEMENT_ID } from '@dealstack/shared/tests/testElementIds.ts';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { TextInput } from 'react-hook-form-mantine';
import { useBankAccountFormContext } from '../../BankAccountFormContext.tsx';
import { BANK_ACCOUNT_FORM_FIELDS, BankAccountFormValues } from '../../types.ts';

// Captured for every bank account, whichever entry format is active — the shell
// renders it (with the currency) at the top of each panel.
export const AccountHolderField = () => {
	const tCapManage = useTranslationCapManage();
	const { control } = useFormContext<BankAccountFormValues>();
	const { hasEditPermission } = useBankAccountFormContext();

	return (
		<TextInput
			control={control}
			name={BANK_ACCOUNT_FORM_FIELDS.account_name}
			label={tCapManage('bank_account.drawer.account_name.label')}
			placeholder={tCapManage('bank_account.drawer.account_name.placeholder')}
			size="md"
			withAsterisk
			disabled={!hasEditPermission}
			data-testid={IBAN_COMPONENT_ELEMENT_ID.ACCOUNT_NAME_INPUT}
		/>
	);
};
